// extracted by mini-css-extract-plugin
module.exports = {"root":"FrontImage_root__iC1df","title":"FrontImage_title__2S2Oi"};